import React from "react";
import styled from "styled-components";
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green
      ? "#0adb93"
      : props.red
      ? "#db0a41"
      : props.layout === "middle"
      ? "#202731"
      : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 50px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function Ticker({ component, game, previewGraphic, allOptaEvents }) {
  return (
    <GraphicButton
      onClick={() => {
        previewGraphic("TeamTicker", {
          game: game,
          team:
            component.data?.name === "HOME_TEAM_TICKER"
              ? game?.home_team
              : game.away_team,
          squads:
            component.data?.name === "HOME_TEAM_TICKER"
              ? game.lineup?.home
              : game.lineup?.away,
          start: true,
          events: allOptaEvents,
        });
      }}
    >
      {component?.data?.label}
    </GraphicButton>
  );
}

export default Ticker;
